<template>
<div class="login">
	<div v-if="getSiteBrand" class="login-logo-wrapper">
		<img v-if="getSiteBrand == 'Flight Deck'" src="@/assets/img/flightdecklogosimple.svg" class="login-logo">
		<img v-if="getSiteBrand == 'Flight Deck Lite'" src="@/assets/img/flightdecklitelogosimple.svg" class="login-logo">
		<img v-if="getSiteBrand == 'FFL Office'" src="@/assets/img/fflofficelogosimple.svg" class="login-logo">
		<img v-if="getSiteBrand == 'Admin'" src="@/assets/img/cdslogo.svg" class="login-logo">
	</div>
	<div v-else class="empty-list">Loading...</div>
	<div>
		<div v-if="forcePasswordChange" class="content" style="min-height: 22em;">
			<h1>Your password has expired</h1>
			<label class="label">Enter a New Password:</label>
			<input type="password" v-model="new_password">
            <label class="label">Retype New Password:</label>
			<input type="password" v-model="retype_password">
			<div></div>
			<button :class="['button', 'forgot', new_password && retype_password && !loading ? 'action' : 'disabled']" @click="doSetNewPassword()">Reset Password</button>
			<div></div>
			<div class="message" >{{ message }}</div>

		</div>
		<div v-if="getSiteBrand" class="content" style="min-height: 22em;">

			<div v-if="getClient.is_demo" style="background-color: #313131; color: white; margin: 0 0 1em 0; padding: 0.5em; text-align: center;">
				<i class="fas fa-exclamation-triangle"></i> Flight Deck is in setup mode! <span style="cursor: pointer" @click="whyDemo = !whyDemo"><b><i>What's this?</i></b></span>
				<div v-if="whyDemo" style="margin: 1em 0 0 0;">
					The domain {{ hostname }} is for account setup.
					<div v-if="getClient.primary_domain && getClient.primary_domain != hostname">
						You can log in to your live account at<br>
						<a :href="'https://' + getClient.primary_domain + '/login.php'" style="color: white;"><b>{{ getClient.primary_domain }}...</b></a>
					</div>
				</div>
			</div>

			<h1>{{ getSiteBrand }} {{ clockInOut ? 'Clock In / Out' : 'Login' }}</h1>
			<h3 v-if="loginRequiredMessage && !clockInOut">{{ loginRequiredMessage }}</h3>
			<label>Username:</label>
			<input type="text" v-model="username" ref="username">
			<div v-if="clockInOut" style="margin: 1em 0 0 0;">
				<div :class="['button', loading || !username ? 'disabled' : 'action']" style="width: 10em; margin: 0 2em 0 0;" @click="doClockInOut('in')">
					Clock In<br>
					<i class="fas fa-clock"></i>
				</div>
				<div :class="['button', loading || !username ? 'disabled' : 'action']" style="width: 10em;" @click="doClockInOut('out')">
					Clock Out<br>
					<i class="fas fa-times"></i>
				</div>
				<div class="message" >{{ message }}</div>
			</div>
			<div v-else>
				<label>Password:</label>
				<input type="password" v-model="password" ref="password" @keyup.enter="doLogin()">
				<div class="controls">
					<div :class="['button', loading ? 'disabled' : 'action']" style="width: 10em;" @click="doLogin()">
						<i v-if="loading" class="fas fa-spinner fa-spin"></i>
						<span v-else>Sign In</span>
					</div>
					<div class="message" >{{ message }}</div>
				</div>
			</div>
			<div></div>
			<div v-if="!clockInOut" class="forgot">
				<router-link class="link" to="/reset-password">Forgot your password?</router-link>
			</div>
		</div>
		<div v-else class="content" style="min-height: 22em;">
			<h1>Oops</h1>
			<h3>Unable to identify client.</h3>
			<div style="margin: 1.5em 0;">Please refresh your browser. If this issue persists, please contact customer service.</div>
		</div>
		<div v-if="getClient.enable_time_sheets" class="content content-control" @click="clockInOut = !clockInOut">
			<i class="fas fa-clock"></i> {{ clockInOut ? 'Return to Login' : 'Clock In / Out' }}
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'login',
	data() {
		return {
			loading: false,
			loginBrand: '',
			username: '',
    		password: '',
    		returnTo: '',
    		showMarketingMessage: false,
    		message: '',
			sessionExpired: false,
			returnAfterLogin: '',
			loginRequiredMessage: '',
			timeSheetsEnabled: '',
			clockInOut: false,
			forcePasswordChange: false,
			new_password: '',
			retype_password: '',
			whyDemo: false,
			hostname: window.location.hostname
		}
	},
	mounted() {
		// if loaded because of a "login_required" there should be a referrer
		// if (this.$route.query.login_required && document.referrer) {
		// 	let referrer = new URL(document.referrer);
		// 	if (referrer.hostname == document.location.hostname) {
		// 		this.returnAfterLogin = referrer.pathname.replace('/dashboard', '')
		// 	}
		// }
		if (this.$route.query.username) {
			this.username = this.$route.query.username
			this.$refs.password.focus()
		} else {
			this.$refs.username.focus()
		}
		//this.returnTo = (this.$route.query.return) ? decodeURI(this.$route.query.return) : ''
		if (this.$route.query.logout && this.getUser.user_id) {
			this.doLogout()
		}
		if (this.$route.query.code == 'expired') {
			this.sessionExpired = true
		}
		if (this.$route.query.login_required) {
			this.loginRequiredMessage = 'Please log in again.'
		}
	},
	methods: {
		doLogin() {
    		if (!this.username || !this.password) return
			if (this.loading) return
		    this.message = ''
			this.loading = true
    		this.apiCall({ destination: 'login', data: { user_name: this.username, password: this.password }}).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					if (obj.user.force_password_change) {
						this.forcePasswordChange = true
						return
					}
					// now that user is logged in, call get_client
					this.apiCall({ destination: 'get_client' }).then(obj => {
						if (obj.reload) {
							// reload vs redirect -- legacy needs to reload
							document.location =  '//' + document.location.host + obj.reload
							return
						}
						this.fetchFlightDeckMenus()
						this.fetchShoppingCartCount()
						let loginResult = JSON.parse(JSON.stringify(obj))

						// would have been set in main App.vue if user was redirected to login
						let returnAfterLogin = localStorage.getItem('return_afer_login')

						if (loginResult.user.user_type_code == 'ADMIN') {
							this.$router.push('/admin')
						} else if (this.$route.query.return) {
							this.$router.push(decodeURI(this.$route.query.return))
						} else if (loginResult.redirect) {
							this.$router.push('/' + loginResult.redirect)
						} else if (loginResult.return) {
							this.$router.push('/' + loginResult.return)
						} else if (returnAfterLogin) {
							localStorage.removeItem('return_afer_login')
							this.$router.push(returnAfterLogin.replace('/dashboard', ''))
						} else {
							this.$router.push(this.getUserHome)
						}
					})
    			} else {
	    			this.message = obj.message
    			}
    		}).catch(err => {
				console.log(err);
			})
    	},
    	doLogout() {
			this.loading = true
    		this.apiCall({ destination: 'logout' }).then(obj => {
				this.loading = false
    			if (obj.status == 'success') {
					//sessionStorage.removeItem('fd_token')
					// remove the token cookie
					document.cookie = "dashboard_token=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
					this.apiCall({ destination: 'get_client' })
				}
    		})
    	},
		doClockInOut(which) {
			if (this.loading) return
			this.loading = true
    		this.apiCall({ destination: 'employee_clock_in_out', data: { user_name: this.username, in_out: which } }).then(obj => {
				this.message = obj.message
				this.loading = false
    			if (obj.status == 'success') {
					setTimeout(() => {
						this.message = ''
						this.clockInOut = false
					}, 1500)
				}
    		})
			
		},
	    doSetNewPassword() {
			if (this.loading) return
		    this.message = ''
    		if (!this.retype_password || !this.new_password || this.loading) return
    		if (this.retype_password != this.new_password) {
	    		this.message = 'Passwords do not match'
	    		return
	    	}
			this.loading = true
    		this.apiCall({ destination: 'reset_password', data: { user_name: this.username, password: this.new_password }}).then(obj => {
    			if (obj.status == 'success') {
					this.message = 'Your password has been reset!'
					setTimeout(() => {
						this.$router.push(this.getUserHome)
					}, 1500)
				} else {
					this.loading = false
	    			this.message = obj.message
    			}
    		})
		}
	}
}
</script>
